import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Offer } from '@innogy/become-a-customer/shared/interfaces';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { DefaultComponentModule } from '@innogy/core/modules/components';

import {
  CommodityOfferContent,
  CommodityOfferLayoutType,
} from '../../commodity-offers.model';
import { CommodityOfferCardComponent } from '../../commodity-offer-card/commodity-offer-card.component';
import { CommodityOfferEssentHeaderComponent } from '../../partials/essent/commodity-offer-header/commodity-offer-header.component';
import { CommodityOfferAccordionComponent } from '../../commodity-offer-accordion/commodity-offer-accordion.component';
import { CommodityOfferPriceBreakdownComponent } from '../../partials/shared/commodity-price-breakdown/commodity-price-breakdown.component';

@Component({
  selector: 'essent-sme-retention-commodity-offer',
  templateUrl: './essent-sme-retention-commodity-offer.component.html',
  standalone: true,
  imports: [
    CommodityOfferCardComponent,
    CommodityOfferEssentHeaderComponent,
    CommodityOfferAccordionComponent,
    AutomationIdDirective,
    CSCaptureDirective,
    CommodityOfferPriceBreakdownComponent,
    DefaultComponentModule,
  ],
})
export class EssentSMERetentionCommodityOfferComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() content?: CommodityOfferContent;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() variant?: CommodityOfferLayoutType;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() offer?: Offer;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showLoadingState = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() active = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() selectableOffer = true;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() enableNewOfferCardTitles? = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() ensureHorizontalAlignment = false;
  @Output() selectOffer = new EventEmitter<void>();
  @Output() viewTariffs = new EventEmitter<void>();

  get setMinimumHeightOfferCardBody() {
    if (!this.selectableOffer) {
      return { 'min-height': 'auto' };
    } else if (
      this.content?.showBudgetbillAmount &&
      !this.content?.enableRemoveBBA
    ) {
      return { 'min-height': '195px' };
    }

    return { 'min-height': '130px' };
  }
}
